import Title from '../Titulo';
import GradeHistoricoRecente from './Grade';

export default function HistoricoRecente() {
    return (
        <>
            <Title>Histórico Tarefas</Title>
            <GradeHistoricoRecente
                sizeTable="medium"
                limit={500} />
        </>
    );
}